import { useQuery } from '@tanstack/react-query';
import { fetchTenant } from '@/lib/api';
import type { TenantConfig } from '@/types/tenant';

export function useTenantQuery(slug: string | undefined) {
  return useQuery<TenantConfig>({
    queryKey: ['tenant', slug],
    queryFn: () => {
      if (!slug) throw new Error('Slug required');
      return fetchTenant(slug);
    },
    enabled: Boolean(slug),
  });
}
